import axios from 'axios';
import isTokenExpired from '../utils/jwt';

// const serverURL = 'http://143.110.243.16:4000';
// const serverURL = 'http://64.227.173.102:4000'; // production
// const serverURL = "http://localhost:3001/"
const serverURL = "https://neelspurchase.com:4001"

const axiosInstance = axios.create({
	baseURL: process.env.REACT_APP_BASE_URL, // API base URL
	headers: {
		'Content-Type': 'application/json',
	},
});

const axiosClientFormData = axios.create({
	baseURL: process.env.REACT_APP_BASE_URL, // API base URL
	headers: {
		'Content-Type': 'multipart/form-data',
	},
});

///////////////////////
// Image Path Helper
///////////////////////
export const generateImagePath = (path: string) => {
	if (!path) return '';
	if (path?.startsWith('http://') || path?.startsWith('https://')) return path;
	return `${serverURL}/${path}`;
};

///////////////////////
// Response Interceptor
///////////////////////
axiosInstance.interceptors.response.use(
	async (response) => {
		return response; // pass successful responses
	},
	async (error) => {
		const originalRequest = error.config;

		if (
			(error.response?.status === 401 ||
				error.response?.data?.message?.toLowerCase()?.includes('token expired')) &&
			!originalRequest._retry
		) {
			originalRequest._retry = true;
			try {
				await refreshOldToken();
				const newAccessToken = localStorage.getItem('accessToken');
				if (newAccessToken) {
					originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
					return axiosInstance(originalRequest);
				}
			} catch (refreshError) {
				console.error('Token refresh failed, logging out...', refreshError);
				localStorage.clear();
				// window.location.href = '/auth-pages/login';
				return Promise.reject(refreshError);
			}
		}
		return Promise.reject(error);
	},
);

///////////////////////
// Request Interceptor
///////////////////////
axiosInstance.interceptors.request.use(
	async (config) => {
		let accessToken: string | null = localStorage.getItem('accessToken');
		const refreshToken: string | null = localStorage.getItem('refreshToken');

		if (accessToken && isTokenExpired(accessToken) && refreshToken) {
			await refreshOldToken();
			accessToken = localStorage.getItem('accessToken');
		}

		if (accessToken) {
			config.headers.Authorization = `Bearer ${accessToken}`;
		}

		return config;
	},
	(error) => {
		console.error('Request error:', error);
		return Promise.reject(error);
	},
);

///////////////////////
// JWT Helpers
///////////////////////
function decodeJWT(token: string) {
	try {
		const payload = token.split('.')[1];
		return JSON.parse(atob(payload));
	} catch (error) {
		console.error('Invalid token', error);
		return null;
	}
}

function getTokenExpiryTime(token: string): Date | null {
	const decoded = decodeJWT(token);
	if (!decoded?.exp) return null;
	return new Date(decoded.exp * 1000); // JWT 'exp' is in seconds
}

///////////////////////
// Refresh Token Logic
///////////////////////
const refreshOldToken = async () => {
	const refreshToken = localStorage.getItem('refreshToken');
	const username = localStorage.getItem('username');
	const accessToken = localStorage.getItem('accessToken');

	if (!refreshToken || !username) return;

	const payload = { username, refreshToken };

	try {
		const result = await axios.post(`${serverURL}/auth/refreshToken`, payload, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${accessToken}`, // optional
			},
		});

		if (result?.data?.status === true) {
			const data = result.data.data;
			console.log("Token dtaa ==> ", data)
			console.log("data.accessToken ==> ", data.accessToken)
			console.log("authTokendata.accessToken ==> ", data.accessToken)
			console.log("data.refreshToken ==> ", data.refreshToken)
			localStorage.setItem('accessToken', data.accessToken);
			localStorage.setItem('authToken', data.accessToken);
			localStorage.setItem('refreshToken', data.refreshToken);

			axiosInstance.defaults.headers.Authorization = `Bearer ${data.accessToken}`;

			console.log('✅ Token refreshed successfully');
		} else {
			console.error('❌ Token refresh failed', result?.data?.message);
			localStorage.clear();
			window.location.href = '/auth-pages/login';
		}
	} catch (error) {
		console.error('❌ Token refresh failed', error);
		localStorage.clear();
		window.location.href = '/auth-pages/login';
	}
};

///////////////////////
// Periodic Token Watcher
///////////////////////
function startTokenExpiryWatcher() {
	setInterval(() => {
		const accessToken = localStorage.getItem('accessToken');
		if (!accessToken) return;

		const expiryDate = getTokenExpiryTime(accessToken);
		if (!expiryDate) return;

		const now = new Date();
		const timeLeftMs = expiryDate.getTime() - now.getTime();

		if (timeLeftMs <= 40 * 1000) {
			console.log('⏳ Token expiring soon, refreshing...');
			refreshOldToken();
		} else {
			console.log(`✅ Token still valid, time left: ${(timeLeftMs / 1000).toFixed(1)}s`);
		}
	}, 30 * 1000); // every 30s
}

// 🔥 Start watcher immediately
startTokenExpiryWatcher();

const getJwtExpiryTime = (token: string): number => {
	const payload = JSON.parse(atob(token.split('.')[1]));
	return payload.exp * 1000;
};

let isRefreshing = false;

// const refreshOldToken = async () => {
// 	if (isRefreshing) return;
// 	isRefreshing = true;

// 	try {
// 		const refreshToken = localStorage.getItem('refreshToken');
// 		const username = localStorage.getItem('username');

// 		if (!refreshToken || !username) throw new Error('Missing token');

// 		const res = await axios.post(
// 			`${serverURL}auth/refreshToken`,
// 			{ username, refreshToken }
// 		);

// 		const data = res.data.data;

// 		localStorage.setItem('accessToken', data.accessToken);
// 		localStorage.setItem('authToken', data.accessToken);
// 		localStorage.setItem('refreshToken', data.refreshToken);

// 		axiosInstance.defaults.headers.Authorization = `Bearer ${data.accessToken}`;

// 		console.log('✅ Token refreshed');
// 	} catch (error) {
// 		console.error('❌ Refresh failed', error);
// 		localStorage.clear();
// 		window.location.href = '/auth-pages/login';
// 	} finally {
// 		isRefreshing = false;
// 	}
// };

// const TOKEN_CHECK_INTERVAL = 60 * 1000; // 1 minute
// const REFRESH_THRESHOLD_MIN = 5;

// setInterval(async () => {
// 	try {
// 		const token = localStorage.getItem('accessToken');
// 		if (!token) return;

// 		const expiryMs = getJwtExpiryTime(token);
// 		const now = Date.now();

// 		const remainingMin = (expiryMs - now) / 1000 / 60;

// 		console.log('⏳ Token expires in', remainingMin.toFixed(2), 'mins');

// 		if (remainingMin < REFRESH_THRESHOLD_MIN) {
// 			await refreshOldToken();
// 		}
// 	} catch (err) {
// 		console.error('Token check error', err);
// 	}
// }, TOKEN_CHECK_INTERVAL);




export default axiosInstance;
export { axiosClientFormData };
